// this file added for individual by Bearer Web Developer
import { ConfirmationResult, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import { flow, Instance, types } from "mobx-state-tree";
import { auth } from "../../api/bearer-api";
export enum SigninSituation {
    Login = 'Login',
    CreateAccount = 'Create Account',
    EnterCodeForSignin = 'Enter Code For Signin',
    CodeExpiredForSignin = 'Code Expired For Signin',
    EnterCodeForSignup = 'Enter Code For Signup',
    CodeExpiredForSignup = 'Code Expired For Signup',
    ReadyForSignup = 'Ready For Signup',
    HearAboutBearer = 'Hear About Bearer',
    Loggedin = 'Loggedin',
}
export const SigninState = types
    .model("SigninState", {
        confirmationResult: types.optional(types.maybeNull(types.frozen<ConfirmationResult | null>()), null),
        situation: types.optional(types.maybeNull(types.frozen<SigninSituation>()), SigninSituation.Login),
        uid: types.maybeNull(types.string),
        loading: types.optional(types.boolean, false),
    })
    .actions(self => {
        return {
            clear() {
                self.confirmationResult = null;
                self.situation = SigninSituation.Login;
                self.uid = null;
                self.loading = false;
            },
            setLoading(loading: boolean) {
                self.loading = loading;
            },
            setSituation(situation: SigninSituation) {
                self.situation = situation;
            },
            setUid(uid: string | null) {
                self.uid = uid;
            },
            setConfirmationResult(confirmationResult: ConfirmationResult | null) {
                self.confirmationResult = confirmationResult;
            },
            resetRecaptcha: async () => {
                try {
                    if (window && document && (window as any)?.grecaptcha) {
                        const el = document?.getElementById('recaptcha-sign-in-container');
                        if (el) {
                            // const recaptchaResponse = (window as any)?.grecaptcha.getResponse((window as any)?.recaptchaWidgetId);
                            // console.log(recaptchaResponse);
                            if ((window as any).recaptchaWidgetId) {
                                await (window as any)?.grecaptcha.reset((window as any).recaptchaWidgetId);
                                return true;
                            } else {
                                // Or, if you haven't stored the widget ID:
                                (window as any).recaptchaWidgetId = await (window as any)?.recaptchaVerifier.render();
                                if ((window as any).recaptchaWidgetId) {
                                    await (window as any)?.grecaptcha.reset((window as any).recaptchaWidgetId);
                                    return true;
                                }
                            }
                        } else {
                            console.log('⚠️ recaptcha-sign-in-container not found in DOM');
                        }
                    }
                } catch (error) {
                    console.log(error);
                    return false;
                }
            }
        }
    }).actions(self => {
        return {
            loginWithPhoneNumberconfirmation: flow(function* (mobile_number: string) {
                try {
                    const appVerifier = (window as any)?.recaptchaVerifier;
                    const confirmationResult: ConfirmationResult = yield signInWithPhoneNumber(auth, mobile_number, appVerifier);
                    if (confirmationResult) {
                        // SMS sent. Prompt user to type the code from the message, then sign the
                        // user in with confirmationResult.confirm(code).
                        self.confirmationResult = confirmationResult;
                        return confirmationResult;
                    }
                    return null;
                } catch (err: any) {
                    // Error; SMS not sent
                    // ...
                    self.resetRecaptcha();
                    // console.log(err); // modify by Bearer Web Developer
                    // console.log(err?.message || 'unknown error');   // throw new Error modified by Bearer Web Developer
                    throw err // added by Bearer Web Developer
                }
            }),
            confirmationResultCode: flow(function* (code: string) {
                try {
                    if (!self.confirmationResult) return null;
                    const result = yield self.confirmationResult.confirm(code);
                    if (result) {
                        // User signed in successfully.
                        const user = result.user;
                        console.log(user);
                        self.confirmationResult = null;
                        return result.user;
                    }
                    return null;
                } catch (err: any) {
                    // User couldn't sign in (bad verification code?)
                    // console.log(err); // modify by Bearer Web Developer
                    // console.log(err?.message || 'unknown error');   // throw new Error modified by Bearer Web Developer
                    throw err // added by Bearer Web Developer
                }
            }),
            renderRecaptchaVerifier: async () => {

                if (!window || !document) return;
                const el = document.getElementById('recaptcha-sign-in-container');
                if (!el) {
                    console.log('⚠️ recaptcha-sign-in-container not found in DOM');
                    return;
                }
                try {
                    if (!(window as any)?.recaptchaVerifier) {
                        (window as any).recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-sign-in-container', {
                            size: 'invisible',
                            callback: (response: any) => {
                                console.log({ response })
                                // reCAPTCHA solved, allow signInWithPhoneNumber.
                                console.log('reCAPTCHA resolved');
                            },
                            'expired-callback': (error: any) => {
                                // Response expired. Ask user to solve reCAPTCHA again.
                                // ...
                                console.log({ error })
                            }
                        });
                    }
                    // pre-render the reCAPTCHA Verifier before submiting a sign-in request
                    if ((window as any).recaptchaVerifier) {
                        (window as any).recaptchaWidgetId = await (window as any)?.recaptchaVerifier.render();
                    }
                } catch (error) {
                    console.log({ error })
                }
            }
        }
    })
export interface ISigninState extends Instance<typeof SigninState> { };

